import Marionette from "backbone.marionette";
import Radio from "backbone.radio";

import ShardModel from "../models/shard";
import environment from "../common/environment";

const channel = Radio.channel("global");

class Shards extends Marionette.Object {
  initialize() {
    this.shard = new ShardModel();
    this.user = channel.request("auth:user");

    // setup channel listeners
    channel.reply("shard:name", this.getShardName, this);
    channel.reply("shard:count", this.getShardCount, this);

    // setup endpoints
    this.endpoint = {
      app: `${environment.getAppHost()}/`,
      environments: `${environment.getAppHost()}/environments`,
    };

    this.start();
  }

  start() {
    const userShards = this.user.getShards();

    // is there a default shard?
    if (this.user.getDefaultShard()) {
      // set the shard
      this.shard = this.user.getDefaultShard();

      // set ajax header
      this.setShardHeader();
    } else if (userShards.length === 1) {
      // automatically select the only available shard
      this.shard = userShards.at(0);

      // persist this shard as the default
      jQuery.ajax({
        context: this,
        url: environment.getEndpoint("defaultShard"),
        method: "PUT",
        contentType: "application/json",
        processData: false,
        data: JSON.stringify(this.shard.toJSON()),
        success() {
          // redirect home
          channel.trigger("auth:app-home");
        },
        error() {
          // show error as alert as status module has not been loaded
          alert(
            "We were unable to set your environment. Please notify your administrator."
          );
        },
      });
    } else {
      // redirect to environments page
      document.location.assign(this.endpoint.environments);
    }
  }

  setShardHeader() {
    // add shard header to jQuery configuration
    jQuery.ajaxSetup({
      headers: {
        "Shard-Id": this.shard.getId(),
      },
    });

    // notify interested parties
    channel.trigger("shard-set", this.shard);
  }

  getShardName() {
    return this.shard.getDescription();
  }

  getShardCount() {
    return this.user.getShards().length;
  }
}

export { Shards as default };
